import { useEffect, useState, useCallback, useRef } from "react";
import api, { errMsg } from "../lib/api";
import { queueRequest } from "../lib/offlineQueue";
import { fmtIDR, fmtDateTime, today } from "../lib/format";
import { PageHeader, Card, Badge, Modal, Field, Btn, DataTable, inputCls } from "../components/common";
import { useAuth } from "../context/AuthContext";
import { Camera, MapPin, Users, CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";

export default function Absensi() {
  const { user, hasPerm, projects } = useAuth();
  const isSuperAdmin = user?.role === "Super Admin";
  const [records, setRecords] = useState([]);
  const [geofence, setGeofence] = useState(null);
  const [showCheckin, setShowCheckin] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [loc, setLoc] = useState(null);
  const [locStatus, setLocStatus] = useState("idle");
  const [type, setType] = useState("in");
  const [members, setMembers] = useState("");
  const [jmlKepala, setJmlKepala] = useState(0);
  const [jmlTukang, setJmlTukang] = useState(0);
  const [jmlKenek, setJmlKenek] = useState(0);
  const [attProject, setAttProject] = useState("");
  const [wageKepala, setWageKepala] = useState("");
  const [wageTukang, setWageTukang] = useState("");
  const [wageKenek, setWageKenek] = useState("");
  const [reason, setReason] = useState("");
  const [filterDate, setFilterDate] = useState(today());
  const [repFilter, setRepFilter] = useState({ project_id: "", start: "", end: "" });
  const [report, setReport] = useState(null);
  const [myStatus, setMyStatus] = useState(null);
  const [compliance, setCompliance] = useState(null);
  const [sickType, setSickType] = useState("ringan");
  const [sickStatement, setSickStatement] = useState(false);
  const [sickFile, setSickFile] = useState(null);
  const [leaveDate, setLeaveDate] = useState("");
  const fileRef = useRef(null);
  const sickRef = useRef(null);

  const onSickFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setSickFile(reader.result);
    reader.readAsDataURL(file);
  };

  const load = useCallback(() => {
    api.get(`/attendance?date=${filterDate}`).then((r) => setRecords(r.data)).catch(() => {});
    api.get("/attendance/geofence").then((r) => setGeofence(r.data)).catch(() => {});
    api.get("/attendance/my-status").then((r) => setMyStatus(r.data)).catch(() => {});
    api.get(`/attendance/compliance?date=${filterDate}`).then((r) => setCompliance(r.data)).catch(() => setCompliance(null));
  }, [filterDate]);
  useEffect(() => { load(); }, [load]);

  const getLocation = () => {
    setLocStatus("loading");
    if (!navigator.geolocation) {
      setLocStatus("error");
      toast.error("Geolocation tidak didukung browser");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (p) => { setLoc({ lat: p.coords.latitude, lng: p.coords.longitude }); setLocStatus("ok"); },
      () => { setLocStatus("error"); toast.error("Gagal mendapatkan lokasi GPS. Aktifkan izin lokasi."); },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  const onPhoto = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const scale = Math.min(1, 1024 / img.width);
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        setPhoto(canvas.toDataURL("image/jpeg", 0.85));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  };

  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (submitting) return;
    if (type === "sakit") {
      if (!reason.trim()) return toast.error("Keterangan sakit wajib diisi");
      if (type === "sakit" && sickType === "ringan" && !sickStatement) return toast.error("Untuk sakit ringan, centang pernyataan pertanggungjawaban");
      if (type === "sakit" && sickType === "berat" && !sickFile) return toast.error("Untuk sakit berat, unggah foto/scan surat keterangan dokter");
    } else {
      if (!photo) return toast.error("Foto wajib diambil/diunggah");
      if (!loc) return toast.error("Lokasi GPS belum didapat");
    }
    setSubmitting(true);
    try {
      const res = await api.post("/attendance", {
        type, photo: photo || "", lat: loc?.lat || 0, lng: loc?.lng || 0,
        project_id: attProject || null,
        reason,
        jumlah_kepala_tukang: +jmlKepala || 0,
        jumlah_tukang: +jmlTukang || 0,
        jumlah_kenek: +jmlKenek || 0,
        wage_kepala_tukang: +wageKepala || 0,
        wage_tukang: +wageTukang || 0,
        wage_kenek: +wageKenek || 0,
        group_members: members ? members.split(",").map((m) => m.trim()).filter(Boolean) : [],
        sick_type: type === "sakit" ? sickType : null,
        sick_statement: type === "sakit" ? sickStatement : false,
        sick_attachment: type === "sakit" && sickFile ? sickFile : "",
        leave_date: type === "cuti" ? leaveDate : null,
      });
      const isLeave = type === "sakit";
      toast.success(isLeave ? "Pengajuan sakit terkirim — menunggu persetujuan" : (res.data.within_geofence ? "Absensi tercatat & terverifikasi otomatis (wajah cocok)" : "Absensi tercatat — DI LUAR geofence, menunggu verifikasi Global Admin"));
      setShowCheckin(false); setPhoto(null); setMembers(""); setJmlKepala(0); setJmlTukang(0); setJmlKenek(0); setWageKepala(""); setWageTukang(""); setWageKenek(""); setReason(""); setSickType("ringan"); setSickStatement(false); setSickFile(null);
      load();
    } catch (e) {
      if (!e.response) {
        queueRequest("/attendance", {
          type, photo: photo || "", lat: loc?.lat || 0, lng: loc?.lng || 0,
          project_id: attProject || null, reason,
          jumlah_kepala_tukang: +jmlKepala || 0, jumlah_tukang: +jmlTukang || 0, jumlah_kenek: +jmlKenek || 0,
          wage_kepala_tukang: +wageKepala || 0, wage_tukang: +wageTukang || 0, wage_kenek: +wageKenek || 0,
          group_members: members ? members.split(",").map((m) => m.trim()).filter(Boolean) : [],
          sick_type: type === "sakit" ? sickType : null,
          sick_statement: type === "sakit" ? sickStatement : false,
          sick_attachment: type === "sakit" && sickFile ? sickFile : "",
          leave_date: type === "cuti" ? leaveDate : null,
        }, "Absensi offline");
        toast.success("Tidak ada koneksi — absensi disimpan offline & otomatis terkirim saat online kembali");
        setShowCheckin(false); setPhoto(null); setMembers(""); setJmlKepala(0); setJmlTukang(0); setJmlKenek(0); setWageKepala(""); setWageTukang(""); setWageKenek(""); setReason(""); setSickType("ringan"); setSickStatement(false); setSickFile(null);
        return;
      }
      toast.error(errMsg(e));
    } finally {
      setSubmitting(false);
    }
  };

  const verify = async (id, action) => {
    try {
      await api.put(`/attendance/${id}/verify`, { action });
      toast.success(action === "reject" ? "Absensi ditolak" : "Absensi terverifikasi — jurnal HPP Konstruksi terbentuk");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const loadReport = async () => {
    try {
      const params = new URLSearchParams();
      if (repFilter.project_id) params.set("project_id", repFilter.project_id);
      if (repFilter.start) params.set("start", repFilter.start);
      if (repFilter.end) params.set("end", repFilter.end);
      const r = await api.get(`/attendance/report?${params.toString()}`);
      setReport(r.data);
    } catch (e) { toast.error(errMsg(e)); }
  };

  const [viewProfile, setViewProfile] = useState(null);
  const isMandor = user?.role === "Mandor";
  const canGroup = ["Mandor", "Manajer Proyek", "Super Admin"].includes(user?.role);
  const canViewAll = ["Super Admin", "Direktur", "Global Admin"].includes(user?.role) || (user?.permissions?.absensi || []).includes("view_all");
  const canMonitor = canViewAll;

  return (
    <div data-testid="absensi-page">
      <PageHeader title="Absensi" subtitle="Tipe 1: Pegawai (foto wajah + GPS) · Tipe 2: Group selfie tukang via akun Mandor / Manajer Proyek" testid="absensi-header">
        {hasPerm("absensi", "create") && (
          <Btn onClick={() => { setShowCheckin(true); setType(canGroup ? "group" : "in"); getLocation(); }} data-testid="checkin-button">
            <Camera className="w-4 h-4" /> Absen Sekarang
          </Btn>
        )}
      </PageHeader>

      {myStatus && !myStatus.checked_in && !isSuperAdmin && (
        <Card className="mb-5 !border-amber-500/50 bg-amber-500/5" testid="wajib-absen-banner">
          <p className="text-sm text-amber-300 font-medium">Anda BELUM absen masuk hari ini.</p>
          <p className="text-xs text-amber-200/70 mt-1">Absensi harian wajib untuk semua pegawai — Anda tidak dapat membuka modul lain sebelum absen masuk.</p>
        </Card>
      )}
      {myStatus && myStatus.checked_in && (
        <div className="flex gap-2 mb-4 flex-wrap" data-testid="my-attendance-status">
          <Badge tone="emerald">Masuk ✓ tercatat</Badge>
          {myStatus.checked_out ? <Badge tone="cyan">Pulang ✓ tercatat</Badge> : <Badge tone="slate">Pulang: belum</Badge>}
        </div>
      )}

      {geofence && (
        <Card className="mb-5" testid="geofence-info">
          <div className="flex flex-wrap items-center gap-4">
            <div className="flex items-center gap-2 text-sm text-slate-300">
              <MapPin className="w-4 h-4 text-emerald-400" />
              <span>{geofence.label || "Titik Geofence"}</span>
            </div>
            <span className="font-mono text-xs text-slate-500" data-testid="geofence-coords">{geofence.lat}, {geofence.lng}</span>
            <Badge tone="cyan">Radius {geofence.radius_m} m</Badge>
          </div>
        </Card>
      )}

      <div className="mb-4 max-w-[200px]">
        <Field label="Filter Tanggal"><input type="date" className={inputCls} value={filterDate} onChange={(e) => setFilterDate(e.target.value)} data-testid="attendance-date-filter" /></Field>
      </div>

      {!canViewAll && (
        <p className="text-xs text-slate-500 mb-2" data-testid="self-history-note">Menampilkan riwayat absensi Anda sendiri. Laporan kehadiran seluruh pegawai hanya dapat dilihat oleh Super Admin, Direktur, dan Global Admin.</p>
      )}
      <DataTable testid="attendance-table" searchKeys={["user_name"]}
        columns={[
          { header: "Waktu", render: (r) => <span className="font-mono text-xs">{fmtDateTime(r.timestamp)}</span> },
          { header: "Nama", accessor: "user_name" },
          { header: "Proyek", render: (r) => <span className="text-xs text-slate-400">{r.project_name || "Kantor Pusat"}</span> },
          { header: "Tipe", render: (r) => <Badge tone={r.type === "group" ? "indigo" : r.type === "in" ? "emerald" : r.type === "out" ? "amber" : "cyan"}>{r.type === "group" ? "GROUP SELFIE" : r.type.toUpperCase()}</Badge> },
          { header: "Ketepatan", render: (r) => r.type === "in" && r.punctuality
              ? (r.punctuality === "terlambat" ? <Badge tone="rose">Telat {r.late_minutes} mnt</Badge> : <Badge tone="emerald">Tepat Waktu</Badge>)
              : r.type === "out" && r.early_leave_minutes > 0
              ? <Badge tone="amber">Pulang cepat {r.early_leave_minutes} mnt</Badge>
              : <span className="text-slate-600">-</span> },
          { header: "Foto", render: (r) => r.photo ? <img src={r.photo} alt="foto absensi" className="w-14 h-10 object-cover rounded border border-slate-700" data-testid={`attendance-photo-${r.id}`} /> : "-" },
          { header: "Anggota Group", render: (r) => r.group_members?.length ? <span className="text-xs text-slate-400 flex items-center gap-1"><Users className="w-3 h-3" />{r.group_members.join(", ")}</span> : "-" },
          { header: "Jarak", render: (r) => <span className="font-mono text-xs text-slate-400">{r.distance_m} m</span> },
          { header: "Geofence", render: (r) => r.within_geofence
              ? <span className="flex items-center gap-1 text-emerald-400 text-xs" data-testid={`geofence-ok-${r.id}`}><CheckCircle2 className="w-3.5 h-3.5" /> Valid</span>
              : <span className="flex items-center gap-1 text-rose-400 text-xs" data-testid={`geofence-fail-${r.id}`}><XCircle className="w-3.5 h-3.5" /> Di Luar</span> },
          { header: "Pekerja", render: (r) => r.type === "group" ? <span className="font-mono text-xs text-slate-300">{r.jumlah_kepala_tukang || 0} KT + {r.jumlah_tukang || 0} tukang + {r.jumlah_kenek || 0} kenek</span> : (r.reason ? <span className="text-xs text-slate-400">{r.reason.slice(0, 40)}</span> : "-") },
          { header: "Status", render: (r) => <Badge tone={{ pending: "amber", verified: "emerald", rejected: "rose" }[r.status || "pending"]}>{(r.status || "pending").toUpperCase()}</Badge> },
          { header: "Verifikasi", render: (r) => r.can_verify && (r.status || "pending") === "pending" ? (
            <div className="flex gap-1.5">
              <Btn className="!px-2.5 !py-1 !text-xs" onClick={() => verify(r.id, "verify")} data-testid={`att-verify-${r.id}`}>Verifikasi</Btn>
              <Btn tone="danger" className="!px-2.5 !py-1 !text-xs" onClick={() => verify(r.id, "reject")} data-testid={`att-reject-${r.id}`}>Tolak</Btn>
            </div>
          ) : (r.verified_by ? <span className="text-[10px] text-slate-500">oleh {r.verified_by}</span> : null) },
        ]}
        rows={records} empty="Belum ada absensi pada tanggal ini" />

      {canMonitor && compliance && compliance.off_day && (
        <Card className="mt-8" testid="compliance-offday"><p className="text-sm text-emerald-400 font-medium">Hari ini hari libur (Minggu / libur nasional) — absensi tidak diwajibkan.</p></Card>
      )}
      {canMonitor && compliance && !compliance.off_day && (
        <div className="mt-8" data-testid="compliance-section">
          <h2 className="text-lg font-medium text-slate-200 mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Monitoring Wajib Absen — {compliance.date}</h2>
          <Card testid="compliance-card">
            <div className="grid grid-cols-3 gap-2 mb-4 text-center">
              <div className="bg-slate-950 border border-slate-800 rounded-lg p-2.5"><div className="text-[10px] font-mono uppercase text-slate-500">Total Pegawai</div><div className="font-mono text-lg text-slate-100">{compliance.summary.total}</div></div>
              <div className="bg-slate-950 border border-slate-800 rounded-lg p-2.5"><div className="text-[10px] font-mono uppercase text-slate-500">Sudah Masuk</div><div className="font-mono text-lg text-emerald-400">{compliance.summary.sudah_masuk}</div></div>
              <div className="bg-slate-950 border border-slate-800 rounded-lg p-2.5"><div className="text-[10px] font-mono uppercase text-slate-500">Belum Masuk</div><div className="font-mono text-lg text-rose-400">{compliance.summary.belum_masuk}</div></div>
            </div>
            <div className="space-y-1.5">
              {compliance.rows.map((r) => (
                <div key={r.user_id} className="flex flex-wrap items-center gap-2 bg-slate-950 border border-slate-800 rounded-lg px-3 py-2" data-testid={`compliance-row-${r.user_id}`}>
                  <span className="text-sm text-slate-200 flex-1 min-w-[120px]">{r.name} <span className="text-[10px] text-slate-500 font-mono">{r.role}</span></span>
                  <button onClick={async () => { try { const pr = await api.get(`/users/${r.user_id}/profile`); setViewProfile(pr.data); } catch (e) { toast.error(errMsg(e)); } }} className="text-[10px] font-mono text-emerald-400 hover:text-emerald-300 border border-emerald-500/40 rounded-full px-2 py-0.5" data-testid={`compliance-profile-${r.user_id}`}>Profil</button>
                  {r.checked_in ? <Badge tone="emerald">Masuk {r.in_at?.slice(11, 16)}</Badge> : <Badge tone="rose">Belum Masuk</Badge>}
                  {r.checked_out ? <Badge tone="cyan">Pulang {r.out_at?.slice(11, 16)}</Badge> : <Badge tone={r.checked_in ? "amber" : "slate"}>Belum Pulang</Badge>}
                </div>
              ))}
              {compliance.rows.length === 0 && <p className="text-slate-500 text-sm">Belum ada pegawai terdaftar selain Super Admin.</p>}
            </div>
          </Card>
        </div>
      )}

      <Modal open={!!viewProfile} onClose={() => setViewProfile(null)} title={viewProfile ? `Profil — ${viewProfile.name}` : ""} testid="pegawai-profile-modal">
        {viewProfile && (
          <div className="text-sm" data-testid="pegawai-profile-content">
            {[["Email", viewProfile.email], ["Role", viewProfile.role],
              ["No. WhatsApp", viewProfile.phone_wa || viewProfile.phone],
              ["NIK", viewProfile.identitas?.nik],
              ["Tempat Lahir", viewProfile.identitas?.tempat_lahir],
              ["Tanggal Lahir", viewProfile.identitas?.tanggal_lahir || viewProfile.identitas?.ttl],
              ["Alamat", viewProfile.alamat],
              ["Pasangan", viewProfile.pasangan?.nama],
              ["Jumlah Anak", (viewProfile.anak || []).length || "-"],
              ["Bank Gaji", viewProfile.rekening_gaji?.bank ? `${viewProfile.rekening_gaji.bank} — ${viewProfile.rekening_gaji.no_rekening || "-"}` : null],
              ["Foto Profil", viewProfile.has_photo ? "Sudah diunggah" : "Belum ada"],
            ].map(([k, v]) => (
              <div key={k} className="flex gap-3 py-1.5 border-b border-slate-800/60 last:border-0">
                <span className="w-32 shrink-0 text-[10px] font-mono uppercase tracking-wider text-slate-500 pt-0.5">{k}</span>
                <span className="text-xs text-slate-200">{v || "-"}</span>
              </div>
            ))}
          </div>
        )}
      </Modal>

      {canViewAll && (
      <div className="mt-8">
        <h2 className="text-lg font-medium text-slate-200 mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Laporan Absensi (Date Range)</h2>
        <Card testid="attendance-report-card">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 items-end mb-4">
            <Field label="Lokasi/Proyek">
              <select className={inputCls} value={repFilter.project_id} onChange={(e) => setRepFilter({ ...repFilter, project_id: e.target.value })} data-testid="report-project-select">
                <option value="">Semua</option>
                {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </Field>
            <Field label="Dari Tanggal"><input type="date" className={inputCls} value={repFilter.start} onChange={(e) => setRepFilter({ ...repFilter, start: e.target.value })} data-testid="report-start-input" /></Field>
            <Field label="Sampai Tanggal"><input type="date" className={inputCls} value={repFilter.end} onChange={(e) => setRepFilter({ ...repFilter, end: e.target.value })} data-testid="report-end-input" /></Field>
            <Btn onClick={loadReport} data-testid="report-run-button">Tampilkan Laporan</Btn>
          </div>
          {report && (
            <div data-testid="report-result">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-4">
                <div className="bg-slate-950 border border-slate-800 rounded-lg p-3"><div className="text-[10px] font-mono uppercase text-slate-500">Total Absensi</div><div className="font-mono text-lg text-slate-100">{report.summary.total}</div></div>
                <div className="bg-slate-950 border border-slate-800 rounded-lg p-3"><div className="text-[10px] font-mono uppercase text-slate-500">Terverifikasi</div><div className="font-mono text-lg text-emerald-400">{report.summary.verified}</div></div>
                <div className="bg-slate-950 border border-slate-800 rounded-lg p-3"><div className="text-[10px] font-mono uppercase text-slate-500">Tukang + Kenek</div><div className="font-mono text-lg text-cyan-400">{report.summary.total_tukang} + {report.summary.total_kenek}</div></div>
                <div className="bg-slate-950 border border-slate-800 rounded-lg p-3"><div className="text-[10px] font-mono uppercase text-slate-500">Total Upah (Verified)</div><div className="font-mono text-lg text-amber-400">{fmtIDR(report.summary.total_upah_terverifikasi)}</div></div>
                <div className="bg-slate-950 border border-slate-800 rounded-lg p-3"><div className="text-[10px] font-mono uppercase text-slate-500">Kepala Tukang / Tukang / Kenek</div><div className="font-mono text-sm text-slate-200">{report.summary.total_kepala_tukang || 0} / {report.summary.total_tukang} / {report.summary.total_kenek} orang</div></div>
              </div>
              <div className="space-y-1.5 max-h-64 overflow-y-auto">
                {report.rows.map((r) => (
                  <div key={r.id} className="flex flex-wrap items-center gap-3 text-xs bg-slate-950 border border-slate-800 rounded-lg px-3 py-2" data-testid={`report-row-${r.id}`}>
                    <span className="font-mono text-slate-400">{fmtDateTime(r.timestamp)}</span>
                    <span className="text-slate-200">{r.user_name}</span>
                    <Badge tone={r.type === "group" ? "indigo" : "cyan"}>{r.type}</Badge>
                    <span className="text-slate-500">{r.project_name || "Kantor Pusat"}</span>
                    <Badge tone={{ pending: "amber", verified: "emerald", rejected: "rose" }[r.status || "pending"]}>{r.status || "pending"}</Badge>
                    {(r.daily_wage > 0 || r.wage_kepala_tukang > 0 || r.wage_tukang > 0 || r.wage_kenek > 0) && <span className="font-mono text-amber-400">{fmtIDR(((r.wage_kepala_tukang || 0) * (r.jumlah_kepala_tukang || 0) + (r.wage_tukang || 0) * (r.jumlah_tukang || 0) + (r.wage_kenek || 0) * (r.jumlah_kenek || 0)) || ((r.daily_wage || 0) * ((r.jumlah_tukang || 0) + (r.jumlah_kenek || 0))))}</span>}
                  </div>
                ))}
                {report.rows.length === 0 && <p className="text-slate-500 text-sm">Tidak ada data pada rentang ini.</p>}
              </div>
            </div>
          )}
        </Card>
      </div>
      )}

      <Modal open={showCheckin} onClose={() => setShowCheckin(false)} title={type === "group" ? "Group Selfie Attendance (Tukang)" : "Absensi Pegawai"} testid="checkin-modal">
        <div className="space-y-4">
          <Field label="Proyek / Lokasi Penugasan (menentukan zona geofence)">
            <select className={inputCls} value={attProject} onChange={(e) => setAttProject(e.target.value)} data-testid="attendance-project-select">
              <option value="">Kantor Pusat (geofence global)</option>
              {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </Field>
          <Field label="Tipe Absensi">
            <select className={inputCls} value={type} onChange={(e) => setType(e.target.value)} data-testid="attendance-type-select">
              {canGroup && <option value="group">Group Selfie (Absen Tukang)</option>}
              <option value="in">Clock In (Masuk)</option>
              <option value="out">Clock Out (Pulang)</option>
              <option value="sakit">Absensi Sakit</option>
            </select>
          </Field>
          <p className="text-[11px] text-slate-500 -mt-2" data-testid="cuti-redirect-hint">Pengajuan cuti kini melalui menu <span className="text-emerald-400">Cuti</span> tersendiri.</p>
          {isMandor && type === "out" && (
            <p className="text-[11px] text-amber-400 -mt-2" data-testid="checkout-progress-hint">Absen pulang Mandor mensyaratkan progress pembangunan hari ini sudah TERVERIFIKASI staff (submit di modul Proyek, tab Progress Harian).</p>
          )}
          {type === "group" && (
            <>
              <Field label="Nama Anggota Tukang (pisahkan koma)">
                <input className={inputCls} placeholder="Contoh: Joko, Slamet, Budi" value={members} onChange={(e) => setMembers(e.target.value)} data-testid="group-members-input" />
              </Field>
              <div className="space-y-2">
                <div className="text-xs font-mono uppercase tracking-wider text-slate-400">Upah per Kategori (Rp/orang/hari) — terjurnal otomatis ke biaya konstruksi</div>
                <div className="grid grid-cols-3 gap-2 items-end">
                  <Field label="Jml Kepala Tukang"><input type="number" min="0" className={inputCls} value={jmlKepala || ""} onChange={(e) => setJmlKepala(+e.target.value)} data-testid="jumlah-kepala-input" /></Field>
                  <Field label="Jml Tukang"><input type="number" min="0" className={inputCls} value={jmlTukang || ""} onChange={(e) => setJmlTukang(+e.target.value)} data-testid="jumlah-tukang-input" /></Field>
                  <Field label="Jml Kenek"><input type="number" min="0" className={inputCls} value={jmlKenek || ""} onChange={(e) => setJmlKenek(+e.target.value)} data-testid="jumlah-kenek-input" /></Field>
                </div>
                <div className="grid grid-cols-3 gap-2 items-end">
                  <Field label="Upah Kepala Tukang"><input type="number" className={inputCls} placeholder="200000" value={wageKepala} onChange={(e) => setWageKepala(e.target.value)} data-testid="wage-kepala-input" /></Field>
                  <Field label="Upah Tukang"><input type="number" className={inputCls} placeholder="150000" value={wageTukang} onChange={(e) => setWageTukang(e.target.value)} data-testid="wage-tukang-input" /></Field>
                  <Field label="Upah Kenek"><input type="number" className={inputCls} placeholder="100000" value={wageKenek} onChange={(e) => setWageKenek(e.target.value)} data-testid="wage-kenek-input" /></Field>
                </div>
                <div className="text-xs font-mono text-amber-300" data-testid="wage-total-preview">Total upah hari ini: {fmtIDR((+wageKepala || 0) * jmlKepala + (+wageTukang || 0) * jmlTukang + (+wageKenek || 0) * jmlKenek)}</div>
              </div>
            </>
          )}
          {type === "sakit" ? (
            <>
            <Field label="Keterangan Sakit (wajib)">
              <textarea className={inputCls} rows={2} placeholder="Contoh: demam, istirahat" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="leave-reason-input" />
            </Field>
            {type === "sakit" && (
              <div className="space-y-3" data-testid="sick-section">
                <Field label="Jenis Sakit (wajib)">
                  <select className={inputCls} value={sickType} onChange={(e) => { setSickType(e.target.value); setSickStatement(false); setSickFile(null); }} data-testid="sick-type-select">
                    <option value="ringan">Sakit Ringan (tanpa surat dokter)</option>
                    <option value="berat">Sakit Berat (wajib surat dokter)</option>
                  </select>
                </Field>
                {sickType === "ringan" ? (
                  <label className="flex items-start gap-2 bg-slate-950 border border-slate-700 rounded-lg px-3 py-2.5 cursor-pointer" data-testid="sick-statement-wrapper">
                    <input type="checkbox" className="mt-0.5 accent-emerald-500" checked={sickStatement} onChange={(e) => setSickStatement(e.target.checked)} data-testid="sick-statement-checkbox" />
                    <span className="text-xs text-slate-300">Pernyataan ini dapat saya pertanggungjawabkan</span>
                  </label>
                ) : (
                  <div>
                    <span className="text-xs font-mono uppercase tracking-wider text-slate-400 block mb-1.5">Lampiran Surat Keterangan Dokter (wajib)</span>
                    <input ref={sickRef} type="file" accept="image/*,application/pdf" onChange={onSickFile} className="hidden" data-testid="sick-file-input" />
                    {sickFile ? (
                      <div className="flex items-center justify-between bg-slate-950 border border-emerald-500/40 rounded-lg px-3 py-2" data-testid="sick-file-preview">
                        <span className="text-xs text-emerald-300">Lampiran terpilih ✓</span>
                        <Btn tone="ghost" className="!text-xs" onClick={() => { setSickFile(null); sickRef.current.value = ""; }}>Ganti File</Btn>
                      </div>
                    ) : (
                      <button onClick={() => sickRef.current.click()} data-testid="sick-upload-button"
                        className="w-full border-2 border-dashed border-slate-700 hover:border-emerald-500/50 rounded-lg py-6 text-slate-500 hover:text-emerald-300 transition-colors flex flex-col items-center gap-2">
                        <Camera className="w-5 h-5" />
                        <span className="text-xs">Unggah foto/scan surat dokter (gambar / PDF)</span>
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}
            </>
          ) : (
          <div>
            {type !== "group" && (
              <Field label="Alasan (WAJIB jika Anda di luar zona geofence)">
                <textarea className={inputCls} rows={2} placeholder="Contoh: survei lokasi konsumen di luar area site" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="geofence-reason-input" />
              </Field>
            )}
            <span className="text-xs font-mono uppercase tracking-wider text-slate-400 block mb-1.5">{type === "group" ? "Foto Group Selfie" : "Foto Wajah (Selfie)"}</span>
            <input ref={fileRef} type="file" accept="image/*" capture="user" onChange={onPhoto} className="hidden" data-testid="photo-file-input" />
            {photo ? (
              <div className="relative">
                <img src={photo} alt="preview" className="w-full rounded-lg border border-slate-700" data-testid="photo-preview" />
                <Btn tone="ghost" className="mt-2 !text-xs" onClick={() => { setPhoto(null); fileRef.current.value = ""; }}>Ulangi Foto</Btn>
              </div>
            ) : (
              <button onClick={() => fileRef.current.click()} data-testid="take-photo-button"
                className="w-full border-2 border-dashed border-slate-700 hover:border-emerald-500/50 rounded-lg py-8 text-slate-500 hover:text-emerald-300 transition-colors flex flex-col items-center gap-2">
                <Camera className="w-6 h-6" />
                <span className="text-xs">Ambil foto / unggah dari galeri</span>
              </button>
            )}
          </div>
          )}
          <div className={`rounded-lg border px-4 py-3 text-xs font-mono ${locStatus === "ok" ? "border-emerald-500/40 text-emerald-300" : locStatus === "error" ? "border-rose-500/40 text-rose-300" : "border-slate-700 text-slate-400"}`} data-testid="gps-status">
            {locStatus === "loading" && "Mengambil koordinat GPS..."}
            {locStatus === "ok" && loc && `GPS: ${loc.lat.toFixed(6)}, ${loc.lng.toFixed(6)}`}
            {locStatus === "error" && (
              <span>GPS gagal. <button className="underline" onClick={getLocation} data-testid="gps-retry-button">Coba lagi</button></span>
            )}
            {locStatus === "idle" && "GPS belum aktif"}
          </div>
          <div className="flex justify-end gap-2">
            <Btn tone="ghost" onClick={() => setShowCheckin(false)}>Batal</Btn>
            <Btn onClick={submit} disabled={submitting || (type !== "cuti" && type !== "sakit" && (!photo || !loc))} data-testid="submit-attendance-button">
              {submitting ? (type === "in" || type === "out" ? "Memverifikasi wajah..." : "Mengirim...") : "Kirim Absensi"}
            </Btn>
          </div>
        </div>
      </Modal>
    </div>
  );
}
